import React from "react";
import styles from './OwnDebugger.module.scss'
import Card, { CardItem } from "../../../../../components/card/Card";
import {
    OWN_STATUS_ERROR,
    OWN_STATUS_IDLE,
    OWN_STATUS_LISTENING, OWN_STATUS_LOADING,
    OWN_STATUS_SUCCESS, OWN_STATUS_WAIT_AGREE
} from "../../../../../settings/content/deploymentOwn";
import Button from "../../../../../components/ripple/Button";

function OwnDebugger({showDebug, status, setStatus, connectError, setConnectError, pushOwnLog}) {

    if (!showDebug) return null;

    const statuses = [OWN_STATUS_WAIT_AGREE, OWN_STATUS_LOADING, OWN_STATUS_IDLE, OWN_STATUS_LISTENING, OWN_STATUS_SUCCESS, OWN_STATUS_ERROR];

    return (
        <div className={styles.layout}>
        <Card title={`</> Own debugger`} className={styles.container}>
            <CardItem className={styles.container__buttons}>
                {statuses.map((s, i) => (
                    <Button
                        displayType={status === s ? 'outlined' : 'text'}
                        visuals={{colorBasic: status === s ? [`var(--colorAccentBasic)`] : [`var(--colorFontBasic)`]}}
                        title={s}
                        onClick={() => setStatus(s)}
                    />
                ))}
            </CardItem>
            <CardItem className={styles.container__buttons}>
                <Button
                    displayType={!!connectError ? 'outlined' : 'text'}
                    visuals={{colorBasic: !!connectError ? [`var(--colorAccentBasic)`] : [`var(--colorFontBasic)`]}}
                    title={`Set connect error`}
                    onClick={() => setConnectError('Some unhandled backend error string example if something went wrong')}
                />
                <Button
                    displayType={!connectError ? 'outlined' : 'text'}
                    visuals={{colorBasic: !connectError ? [`var(--colorAccentBasic)`] : [`var(--colorFontBasic)`]}}
                    title={`Clear error`}
                    onClick={() => setConnectError('')}
                />
            </CardItem>
            <CardItem className={styles.container__buttons}>
                <Button
                    displayType='text'
                    title={`Add log (success)`}
                    onClick={() => {
                        pushOwnLog('Some unhandled backend error string example if something went wrong', 'something', 'success')
                    }}
                />
                <Button
                    displayType='text'
                    title={`Add log (error)`}
                    onClick={() => {
                        pushOwnLog('Some unhandled backend error string example if something went wrong', 'error', 'error')
                    }}
                />
                <Button
                    displayType='text'
                    title={`Add log (warning)`}
                    onClick={() => {
                        pushOwnLog('Some unhandled backend error string example if something went wrong', 'blah', 'warning')
                    }}
                />
                <Button
                    displayType='text'
                    title={`Add log (info)`}
                    onClick={() => {
                        pushOwnLog('Some unhandled backend error string example if something went wrong', 'kek', 'info')
                    }}
                />
                <Button
                    displayType='text'
                    title={`Add log (very long)`}
                    onClick={() => {
                        pushOwnLog('awdwadwadwaawdwadwadwaawdwadwadwaawdwadwadwaawdwadwadwaawdwadwadwaawdwadwadwaawdwadwadwaawdwadwadwaawdwadwadwaawdwadwadwaawdwadwadwaawdwadwadwaawdwadwadwaawdwadwadwa', 'kek', 'info')
                    }}
                />
            </CardItem>
        </Card>
        </div>
    )
}

export default OwnDebugger